import "./planpagelayout.css";
import { PlanLife } from "./plan";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { PayHeader } from "../Paymentheader/PayHeader";
import { EditOutlined, FilterOutlined } from "@ant-design/icons";
import { Modal, Dropdown, Space } from "antd/lib";
import LifeInsurerFilter from "./InsurerFilter";
import ShareQImage from "../../assets/share quote.png";
import EditDetailLife from "./EditDetails";
import PayModeLife from "./PayMode";
import LifeCover from "./LifeCover";
import CoverTilAge from "./CoverTill";
import PayTillAge from "./PayTill";
import { SelectedPayTill, PayTillUpdate } from "../../Redux/actions/NumLife";

function PlanLayoutLife() {
  const dispatch = useDispatch();
  const history = useHistory();
  const QuickQuotes = useSelector((state) => state?.lifedetail?.quickquotes);
  const QuickQuotePost = useSelector(
    (state) => state?.lifedetail?.QuickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.healthdetail?.quoteInput);
  const FamDetails = useSelector((state) => state?.lifedetail?.cusInfo);
  const SQQPlanMode = useSelector((state) => state?.common?.selectedLifePlan);
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const Paytill = useSelector((state) => state?.common?.paytillUpdate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ModelOpenMember, setIsModalOpenMember] = useState(false);
  const [isModalInsurer, setisModalInsurer] = useState(false);
  const [isModalPayTill, setisModalPayTill] = useState(false);
  const [isModalMultiyr, setisModalMultiYr] = useState(false);
  const [isModalCover, setisModalCover] = useState(false);
  const [isModalSendPdf, setisModalSendPdf] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [coverTill, setCoverTill] = useState("");
  const [payTill, setPayTill] = useState(null);
  const shortlistedQuotesLength = QuickQuotes?.filter(
    (quote) => quote?.selected
  )?.length;
  //  console.log('SQQPlanMode',SQQPlanMode)
  const handleScroll = () => {
    if (window.scrollY > 80) {
      setScrolled(true);
      // console.log(scrolled);
    } else {
      setScrolled(false);
      // console.log(scrolled);
    }
  };

  useEffect(() => {
    validatePolicyTerm();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [CusDeatail]);

  const validatePolicyTerm = () => {
    // console.log('value',value)
    const PTerm = parseInt(CusDeatail?.PolicyTerm);
    const age = parseInt(CusDeatail?.Age);
    const selectedAgeGap = PTerm + age;
    console.log("selectedAgeGap", selectedAgeGap);
    setCoverTill(selectedAgeGap);
    const PremTerm = parseInt(QuickQuotePost?.PremiumTerm);
    const Premage = parseInt(CusDeatail?.Age);
    const selectedPremAgeGap = PremTerm + Premage;
    console.log(selectedPremAgeGap);
    setPayTill(selectedPremAgeGap);

    dispatch(PayTillUpdate(selectedPremAgeGap));
  };
  const payYearClick = () => {
    setIsModalOpen(true);
  };
  const HandleInsurer = () => {
    setisModalInsurer(true);
  };
  const HandlePayTill = () => {
    setisModalPayTill(true);
  };
  const HandleMultiYr = () => {
    setisModalMultiYr(true);
  };
  const HandleMember = () => {
    setIsModalOpenMember(true);
  };
  const HandleCover = () => {
    setisModalCover(false);
  };
  const handleCancelMem = () => {
    setIsModalOpenMember(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancelInsurer = () => {
    setisModalInsurer(false);
  };
  const handleCancelPlanType = () => {
    setisModalPayTill(false);
  };
  const handleCancelMulYr = () => {
    setisModalMultiYr(false);
  };
  const handleCancelCover = () => {
    setisModalCover(false);
  };
  const handleCancelPdf = () => {
    setisModalSendPdf(false);
  };
  const items = [
    {
      label: "All Quotes",
      key: "0",
    },
    {
      label: "Shortlisted Quote",
      key: "1",
      disabled: shortlistedQuotesLength === 0,
    },
  ];
  const onClick = ({ key }) => {
    console.log(key);
    if (key === "0") {
      setisModalSendPdf(true);
    }
  };
  function convertAmountToLakhs(amount) {
    const lakhs = Math.floor(amount / 100000);
    return `${lakhs} lakhs`;
  }

  const convertedAmount = convertAmountToLakhs(QuickQuotePost?.SumProposed);
  console.log(convertedAmount);

  return (
    <div>
      <PayHeader />
      <div className={scrolled ? `sticky-life` : `life-detail-head`}>
        <div className="healthinner-t">
          <div className="inner-f-health">
            <div className="d-flex align-items-center">
              <div className="H-border"></div>
              <div className="health-e">Edit Details</div>
              <div className="d-health-icon">
                <EditOutlined
                  key="save"
                  style={{ cursor: "pointer" }}
                  onClick={HandleMember}
                />
              </div>
              <div className="life-edit-Det img-0">
                <ul>
                  <li>
                    {FamDetails?.gender === "M"
                      ? "Male"
                      : FamDetails?.gender === "F"
                      ? "Female"
                      : null}
                  </li>
                  <li>{FamDetails?.Age} Years</li>
                  <li>
                    {FamDetails?.IsSmoker === "Y"
                      ? "Smoker"
                      : FamDetails?.IsSmoker === "N"
                      ? "Non Smooker"
                      : null}
                  </li>
                  <li>{FamDetails?.Occupation}</li>
                  <li>{FamDetails?.Education}</li>
                </ul>
              </div>
            </div>
            <div className="health-share img-0">
              <img src={ShareQImage} style={{ width: "25px" }}></img>
              <span>
                <Dropdown
                  menu={{
                    items,
                    onClick,
                  }}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>Share Quotes</Space>
                  </a>
                </Dropdown>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="life">
        <div className="container">
          <div className={`editquote-life row`}>
            <div className="editLife col-xl-2 col-lg-2 col-md-2 col-sm-6">
              <p className="mb-0">Pay</p>
              <p
                className="mb-0"
                style={{ color: "orange", cursor: "pointer" }}
                onClick={payYearClick}
              >
                {SQQPlanMode}
              </p>
            </div>
            <div className="editLife col-xl-2 col-lg-2 col-md-2 col-sm-6">
              <p className=" mb-0">Life Cover</p>
              <p
                className="mb-0"
                style={{ color: "orange", cursor: "pointer" }}
                onClick={HandleMultiYr}
              >
                {convertedAmount}
              </p>
            </div>
            <div className="editLife col-xl-2 col-lg-2 col-md-2 col-sm-6">
              <p className=" mb-0">Cover Till Age</p>
              <p
                className="mb-0"
                style={{ color: "orange", cursor: "pointer" }}
                onClick={HandleCover}
              >
                {coverTill} Years
              </p>
            </div>
            <div className="editLife col-xl-2 col-lg-2 col-md-2 col-sm-6">
              <p className=" mb-0">Pay Till Age</p>
              <p
                className="mb-0"
                style={{ color: "orange", cursor: "pointer" }}
                onClick={HandlePayTill}
              >
                {/* {Paytill ? Paytill : payTill}{' '}Years */}
                {Paytill} Years
              </p>
            </div>
            <div className="editLife col-xl-2 col-lg-2 col-md-2 col-sm-6">
              <p className=" mb-0">Insurance Company</p>
              <p
                className="mb-0"
                style={{ color: "orange", cursor: "pointer" }}
                onClick={HandleInsurer}
              >
                <FilterOutlined />
              </p>
            </div>
            {/* </div> */}
          </div>
          <PlanLife />
        </div>
      </div>
      <Modal
        title="Edit Details"
        open={ModelOpenMember}
        footer={null}
        onCancel={handleCancelMem}
        maskClosable={false}
        width={900}
      >
        <EditDetailLife setIsModalOpenMember={setIsModalOpenMember} />
      </Modal>
      <Modal
        title="Pay Mode"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        maskClosable={false}
        width={350}
      >
        <PayModeLife setIsModalOpen={setIsModalOpen} />
      </Modal>
      <Modal
        className="modal-mx-heigh"
        title="Sum Insured"
        open={isModalMultiyr}
        footer={null}
        onCancel={handleCancelMulYr}
        maskClosable={false}
        width={350}
      >
        <LifeCover setisModalMultiYr={setisModalMultiYr} />
      </Modal>

      <Modal
        title="Cover Age"
        className="Health-Modal"
        open={isModalCover}
        footer={null}
        onCancel={handleCancelCover}
        maskClosable={false}
        width={350}
      >
        <CoverTilAge setisModalCover={setisModalCover} />
      </Modal>
      <Modal
        title="Pay Till"
        open={isModalPayTill}
        footer={null}
        onCancel={handleCancelPlanType}
        maskClosable={false}
        width={350}
      >
        <PayTillAge
          setisModalPayTill={setisModalPayTill}
          coverTill={coverTill}
        />
      </Modal>
      <Modal
        title="please choose the way you wish to share the quotes."
        open={isModalSendPdf}
        // footer={null}
        footer="* Please note that the premium may vary in future."
        onCancel={handleCancelPdf}
        maskClosable={false}
      >
        {/* <SendToCustomer setisModalSendPdf={setisModalSendPdf} isModalSendPdf={isModalSendPdf}/> */}
      </Modal>
      <Modal
        title="Preferred Insurer"
        open={isModalInsurer}
        footer={null}
        onCancel={handleCancelInsurer}
        maskClosable={false}
      >
        <LifeInsurerFilter setisModalInsurer={setisModalInsurer} />
      </Modal>
    </div>
  );
}

export { PlanLayoutLife };
